import { Button, Card, Col, Form, Table } from "react-bootstrap";
import { JConfirmDelete, JRow, MensagemModal } from "../../../components/Components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { Link } from "react-router-dom";
import { infTermDescarregInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useRef, useState } from "react";
import { formatMoeda, getUuidV4, goToFocus } from "../../../utils/utils";
import { addTerminalDescarrega, removeTerminalDescarrega } from "../../../features/manifestoSlice";

const LIMITE: number = 5;

const initialState: infTermDescarregInterface = {
    id: 0,
    ctermdescarreg: '',
    xtermdescarreg: '',
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

export default function TerminalDescarregamento() {
    const dispatch = useDispatch();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.modal_aquatico.infTermDescarreg);
    const [form, setForm] = useState<infTermDescarregInterface>(initialState);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const codTerminal = useRef<HTMLInputElement>(null)
    const nomeTerminal = useRef<HTMLInputElement>(null)

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const validaPreenchimento = () => {
        if (form.ctermdescarreg.toString() === "") {
            alerta('Informe o Código do terminal');
            goToFocus(codTerminal);
            return false;
        }

        if (form.xtermdescarreg.toString() === "") {
            alerta('Informe o nome do terminal');
            goToFocus(nomeTerminal);
            return false;
        }

        if (lista.length >= LIMITE) {
            alerta(`Limite de ${formatMoeda(LIMITE, 0)} terminais atingido.`);
            return false;
        }

        if (lista.find((item: infTermDescarregInterface) =>
            item.ctermdescarreg.trim() === form.ctermdescarreg.trim())) {
            alerta('Código do terminal já adicionado.');
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addTerminalDescarrega({ ...form, id: getUuidV4() }))
            setForm(initialState);
            goToFocus(codTerminal);
        }
    }

    const handleRemover = (id: number) => {
        dispatch(removeTerminalDescarrega(id));
        setShowModal(false);

    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    return (<>
        <Card className="card-primary card-outline">
            <Card.Header>Informações dos terminais de descarregamento <span
                className="text-primary fw-semibold">(Opcional)</span>
            </Card.Header>
            <Card.Body>
                <JRow className="mb-3">
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>* Código do Terminal</Form.Label>
                            <Form.Control type="text" name="ctermdescarreg" maxLength={8} value={form.ctermdescarreg}
                                ref={codTerminal}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group>
                            <Form.Label>* Nome do Terminal</Form.Label>
                            <Form.Control type="text" name="xtermdescarreg" maxLength={60} value={form.xtermdescarreg}
                                ref={nomeTerminal}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex  align-items-end">
                        <Button variant="primary" onClick={handleAdd}>
                            <FontAwesomeIcon icon={faPlus} />  Adicionar
                        </Button>
                    </Col>
                </JRow>

                <Table striped bordered hover size="sm" responsive>
                    <thead className="table-light">
                        <tr>
                            <th className="text-center">#</th>
                            <th className="text-center" style={{ width: '11rem' }}>Cód. Terminal</th>
                            <th className="text-center" >Nome Terminal</th>
                        </tr>
                    </thead>

                    <tbody>
                        {lista?.map((item: infTermDescarregInterface) => (
                            <tr key={item.id}>
                                <td className="text-center">
                                    <Link to={''} className="text-danger"
                                        onClick={() => handleOpenModal({ id: item.id, title: item.xtermdescarreg })}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </Link>
                                </td>
                                <td className="text-center">{item.ctermdescarreg}</td>
                                <td className="text-center">{item.xtermdescarreg}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={selected.title}
            id={selected.id}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}